import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableService } from "src/app/_metronic/shared/crud-table";
import { environment } from "src/environments/environment";
import { Email } from "../models/email.model";

@Injectable({
  providedIn: "root",
})
export class EmailPromotionsService
  extends TableService<Email>
  implements OnDestroy
{
  BASE_URL = environment.apiUrl;
  GET_ALL_URL = "EmailPromotion";
  CREATE_URL = "EmailPromotion";
  GET_ONE_URL = "EmailPromotion";

  constructor(
    @Inject(HttpClient) http,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(http, router, activatedRoute);
  }

  sendEmailPromotions(email: Email) {
    return this.http.post(`${this.BASE_URL}/${this.CREATE_URL}`, email);
  }

  getEmails() {
    return this.http.get<Email[]>(`${this.BASE_URL}/${this.GET_ALL_URL}`);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  testEmail(email: Email){
    return this.http.post(`${this.BASE_URL}/${this.CREATE_URL}/SendTestEmail`, email);
  }
}
